class ProductInfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.type = this.dataset.type;
    this.wrapper = this.querySelector('.products');
    this.loadMoreButton = document.getElementById('load-more-products');
    this.currentPage = parseInt(this.wrapper.dataset.infiniteCurrent, 10);
    this.maxArticlesPerPage = parseInt(this.wrapper.dataset.infiniteMax, 10);
    this.totalPages = parseInt(this.wrapper.dataset.infinitePages, 10);
    this.nextUrl = this.wrapper.dataset.infiniteNext;

    this.updateProductCount();

    const urlHash = window.location.hash.replace('#', '');
    if (urlHash && !isNaN(urlHash) && parseInt(urlHash, 10) > 1) {
      const targetPage = parseInt(urlHash, 10);
      this.loadProductsUpToPage(targetPage);
    }

    this.bindEventListeners();
  }

  bindEventListeners() {
    if (this.type === 'onClick' && this.loadMoreButton) {
      this.loadMoreButton.addEventListener('click', () => {
        //this.loadMoreProducts.bind(this);
        this.loadMoreProducts();
      });
    }

    if (this.type === 'onScroll' && this.loadMoreButton) {
      const observer = new IntersectionObserver(this.handleIntersection.bind(this), {
        root: null,
        rootMargin: '0px',
        threshold: 1.0,
      });

      observer.observe(this.loadMoreButton);
    }
  }

  async loadProductsUpToPage(targetPage) {
    while (this.currentPage < targetPage && this.currentPage < this.totalPages) {
      await this.loadMoreProducts(false);
    }
  }

  async loadMoreProducts(updateHash = true) {
    if (this.currentPage >= this.totalPages) {
      this.loadMoreButton.style.display = 'none';
      return;
    }

    this.currentPage++;
    this.loadMoreButton.setAttribute('aria-disabled', 'true');
    this.loadMoreButton.classList.add('is-loading');

    try {
      const response = await fetch(this.nextUrl.replace('[% page %]', this.currentPage));
      const htmlText = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');
      const newProducts = doc.querySelectorAll('product-item');

      newProducts.forEach((article) => {
        this.wrapper.appendChild(article);
      });

      const newWrapper = doc.querySelector('.products');
      this.nextUrl = newWrapper.dataset.infiniteNext;

      if (updateHash) {
        window.location.hash = this.currentPage;
      }

      if (this.currentPage >= this.totalPages) {
        this.loadMoreButton.style.display = 'none';
      }

      this.updateProductCount();
    } catch (error) {
      console.error('Error loading more products:', error);
    } finally {
      this.loadMoreButton.removeAttribute('aria-disabled');
      this.loadMoreButton.classList.remove('is-loading');
    }
  }

  updateProductCount() {
    const productsVisible = this.wrapper.querySelectorAll('product-item')?.length;
    if (productsVisible) {
      const productCountElement = document.querySelector('.product__infinite--products-viewing');
      productCountElement.textContent = `${productsVisible}`;
      if (this.totalPages === 1) {
        this.loadMoreButton.style.display = 'none';
      }
    }
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !this.loadMoreButton.getAttribute('aria-disabled')) {
        this.loadMoreProducts();
      }
    });
  }
}

customElements.define('product-infinite-scroll', ProductInfiniteScroll);
